import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import type { UploadPresignedFileResult } from "@retro-ia/shared/upload";

export interface CreateIntentoDto {
  idActividadAprendiz: number | undefined;
  archivo: UploadPresignedFileResult;
  retro: string;
  sessionId: string;
  sessionPayload: string;
  preguntasSugeridas?: string[];
}

export interface Intento {
  id: number;
  idActividadAprendiz: number;
  archivo: UploadPresignedFileResult;
  retro: string;
  creadoEl: Date;
  creadoPor: string;
  actualizadoEl: Date;
  actualizadoPor: string;
  isActivo: boolean;
  isOculto: boolean;
  sessionPayload: string;
}

export function useCreateIntento() {
  return useMutation({
    mutationFn: async (dto: CreateIntentoDto) => {
      const res = await axiosInstance.post("/intentos", dto);
      return res.data;
    },
    onError: (error) => {
      console.error("Error al crear el intento:", error);
    },
  });
}

export function useUpdatePreguntasUsadas() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ idIntento, preguntasUsadas }: { idIntento: number; preguntasUsadas: string[] }) => {
      const res = await axiosInstance.patch(`/intentos/${idIntento}/preguntas-usadas`, {
        preguntasUsadas,
      });
      return res.data;
    },
    onSuccess: () => {
      // Invalidar queries de actividadAprendiz para refrescar los datos
      queryClient.invalidateQueries({
        queryKey: ["actividadAprendiz"],
      });
    },
    onError: (error) => {
      console.error("Error al actualizar preguntas usadas:", error);
    },
  });
}
